<template>
  <v-form ref="form" :value="valid" @input="v => $emit('update:valid', v)">
    <v-row align="center" dense>
      <v-col cols="12">
        <v-text-field
          dense
          hide-details
          filled
          class="no-before"
          label="Nom du gabarit"
          :value="name"
          @change="v => $emit('update:name', v)"
          :rules="[
            v => !!v || 'Un nom est requis',
            v => v != '' || 'Un nom est requis',
            v => v != ' ' || 'Un nom est requis'
          ]"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="6" md="4">
        <j-decimal-input
          dense
          filled
          hide-details
          class="no-before"
          suffix="$"
          label="Montant des ventes estimé pour ce gabarit"
          hint="Laisser vide pour ignorer"
          persistent-hint
          :value="sales_target"
          @input="v => $emit('update:sales_target', v > 0 ? v : null)"
        ></j-decimal-input>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  name: "PreparationSlipTemplateFields",
  props: {
    name: {
      required: true
    },
    comments: {
      required: true
    },
    sales_target: {
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    reset() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style></style>
